/* @flow */
import * as React from 'react';

const DonationSmallAlt = props => (
  <svg
    width={62}
    height={55}
    viewBox="0 0 62 55"
    fillRule="evenodd"
    stroke="#1D2C61"
    strokeWidth={2}
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}>
    <polygon
      stroke="none"
      strokeWidth={1}
      fill="#E8EBF7"
      points="1.5 29.689 38.194 29.689 38.194 23.03 1.5 23.03"
    />
    <polygon points="1 29 37 29 37 22 1 22" />
    <polygon points="3 54 36 54 36 29 3 29" />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#677BC5"
      d="M23.897,34.108 C23.897,34.108 29.251,28.013 30.563,22.261 C31.874,16.509 30.008,15.643 26.875,15.054 C23.741,14.464 21.84,14.053 22.418,12.023 C22.995,9.993 26.875,8.122 26.875,8.122 C26.875,8.122 24.655,5.843 28.006,4.04 C31.358,2.238 33.465,1.591 36.295,1.5 C39.124,1.41 39.741,3.305 37.971,5.046 C36.2,6.786 34.213,12.839 39.251,16.18 C44.289,19.52 53.852,23.582 56.571,27.979 C59.29,32.376 60.684,34.231 60.798,41.873 C60.913,49.514 59.215,54.46 50.82,54.46 L36.295,54.46 C36.295,54.46 26.544,53.948 26.544,45.836"
    />
    <polygon stroke="none" strokeWidth={1} fill="#FFFFFF" points="4 53 45 53 45 30 4 30" />
    <polygon stroke="none" strokeWidth={1} fill="#E8EBF7" points="4 53 14 53 14 30 4 30" />
    <path d="M37.521,54 L52.235,54 C52.235,54 60.819,53.959 60.819,44.237 C60.819,34.514 60.536,28.001 48.651,21.487 C36.766,14.974 36.766,14.03 36.766,9.499 C36.766,4.968 39.124,3.08 39.124,3.08 C39.124,3.08 37.898,0.249 33.276,1.193 C28.655,2.136 24.976,5.44 26.485,7.234 L28.781,9.541" />
    <path d="M26.142,8 C26.142,8 21.958,10.45 22.052,12.618 C22.147,14.786 29.976,13.184 30.919,17.33 C31.862,21.477 27.491,29 27.491,29" />
    <path d="M30.919,18.01 C30.919,18.01 30.721,14.374 37.062,13.981" />
    <polygon points="15 54 44 54 44 36 15 36" />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#FFF055"
      d="M33.28,41.76 C32.319,40.747 30.763,40.747 29.802,41.76 L29.5,42.079 L29.198,41.76 C28.237,40.747 26.681,40.747 25.72,41.76 C24.76,42.774 24.76,44.417 25.72,45.431 L26.022,45.751 L28.817,48.702 C29.194,49.099 29.805,49.099 30.182,48.702 L32.978,45.751 L33.28,45.431 C34.24,44.417 34.24,42.774 33.28,41.76"
    />
    <path
      stroke="#273060"
      d="M33.28,41.76 C32.319,40.747 30.763,40.747 29.802,41.76 L29.5,42.079 L29.198,41.76 C28.237,40.747 26.681,40.747 25.72,41.76 C24.76,42.774 24.76,44.417 25.72,45.431 L26.022,45.751 L28.817,48.702 C29.194,49.099 29.805,49.099 30.182,48.702 L32.978,45.751 L33.28,45.431 C34.24,44.417 34.24,42.774 33.28,41.76"
    />
    <polygon points="13 36 46 36 46 29 13 29" />
  </svg>
);

export default DonationSmallAlt;



// WEBPACK FOOTER //
// ./src/assets/images/icons/donation-small-alt.js